import { render, staticRenderFns } from "./booking-consume-dialog.vue?vue&type=template&id=be46dbb8&scoped=true"
import script from "./booking-consume-dialog.vue?vue&type=script&lang=js"
export * from "./booking-consume-dialog.vue?vue&type=script&lang=js"
import style0 from "./booking-consume-dialog.vue?vue&type=style&index=0&id=be46dbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be46dbb8",
  null
  
)

export default component.exports